import generatePicker from 'antd/es/date-picker/generatePicker';
import 'antd/es/date-picker/style/index';
import dateFnsGenerateConfig from './dateFnsDatePickerConfig';
import type { RangeValue } from 'rc-picker/lib/interface';

const DatePicker = generatePicker<Date>(dateFnsGenerateConfig);

/**
 * Overrides the Antd Date picker's default library with date-fns (replacing dayjs).
 */
export default DatePicker;

/**
 * Set from and to date for range picker
 * @param setFrom function for setting the from date.
 * @param setTo function for setting the to date.
 */
export const onRangeChange =
  (setFrom: (input: Date) => void, setTo: (input: Date) => void) =>
  (rangeDates: RangeValue<Date> | null) => {
    if (
      rangeDates !== null &&
      rangeDates[0] !== null &&
      rangeDates[1] !== null
    ) {
      setFrom(rangeDates[0]);
      setTo(rangeDates[1]);
    }
  };
